import styled from "@emotion/styled";
export const StyledParagraphAndLogos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .paragraph-wrapper {
  }

  .logos-wrapper {
  }
`;
